// Copyright © 2021 Move Closer
export const shareServiceConfig = {
    facebook: {
        appId: process.env.VUE_APP_D24_FACEBOOK_APP_ID || '140586622674265'
    }
};
